import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { navigateAction, NavLink } from 'fluxible-router';
import { isUndefined } from 'lodash-es';
import UserModel from '../../../models/user';
import logoutAccount from '../../../actions/account/logout';
import SpotSelector from './spot-selector/index';
import { getIsEmbeddedAnalyticsEnabled } from './utils';

import cloudinary from 'app/scripts/utils/cloudinary';
import { getNetwork, isDefaultNetwork } from 'app/scripts/services/app-state';
import Icon from 'utils/components/icon';
import Droplist from 'utils/components/droplist';
import Tooltip from 'utils/components/tooltip';

const spotsWithTopicPagesAlways = ['sp_v0xu5oCZ', 'sp_JRGmW7Ab'];

class MainNavigation extends Component {
  state = {};

  async componentDidMount() {
    var { spotId, isSuperAdmin, isAdmin } = this.props;
    if (isAdmin || isSuperAdmin) {
      const isEmbeddedAnalyticsEnabled = await getIsEmbeddedAnalyticsEnabled(spotId);
      this.setState({ isEmbeddedAnalyticsEnabled });
    }
  }

  navigateToSpot() {
    var spotIds = this.props.spotSelector.spots.map(spot => spot.id);
    if (spotIds.length > 0) {
      this.context.executeAction(navigateAction, {
        url: `/spot/${spotIds[0]}/moderation`
      });
    }
  }

  navigateSupport() {
    window.location = 'mailto:publisherfirst@openweb.com';
  }

  logout() {
    var { spotId } = this.props;
    this.context.executeAction(logoutAccount, { spotId });
  }

  openContextMenu() {
    var items = [
      <span onClick={this.navigateSupport.bind(this)}>
        <div className="icon-wrapper">
          <Icon name="support" className="support-icon" />
          <span>Support</span>
        </div>
      </span>,
      <span onClick={this.logout.bind(this)}>
        <div className="icon-wrapper">
          <Icon name="logout" className="logout-icon" />
          <span>Log out</span>
        </div>
      </span>
    ];

    return <Droplist items={items} />;
  }

  openSettings() {
    this.refs.menu.toggle();
  }

  render() {
    var {
      visible,
      spotId,
      showLinks,
      hasDropdown,
      text,
      currentRoute,
      currentUser,
      spotSelector,
      isAdmin,
      isSuperAdmin,
      spot
    } = this.props;
    const { isEmbeddedAnalyticsEnabled } = this.state;

    const ssoEnabled = spot && spot.ssoEnabled;

    if (!visible) {
      return null;
    }
    var menuItems = [];
    menuItems.push({
      label: 'Moderation',
      routeName: 'moderation',
      navParams: { spot_id: spotId }
    });

    if (isAdmin || isSuperAdmin) {
      menuItems.push(
        { label: 'Settings', routeName: 'preferences', navParams: { spot_id: spotId } },
        { label: 'Features', routeName: 'features', navParams: { spot_id: spotId } }
      );

      if (!isUndefined(isEmbeddedAnalyticsEnabled)) {
        if (isEmbeddedAnalyticsEnabled) {
          menuItems.push(
            {
              label: 'Analytics',
              routeName: 'analytics-next',
              navParams: { spot_id: spotId }
            },
            {
              label: 'Revenue',
              routeName: 'revenue-next',
              navParams: { spot_id: spotId }
            }
          );
        } else {
          menuItems.push({
            label: 'Analytics',
            routeName: 'analytics',
            navParams: { spot_id: spotId }
          });
        }
      }
    }

    var menuComponents = [];
    if (spotId) {
      menuItems.forEach(item => {
        var className = classnames('item', {
          active: currentRoute.page.indexOf(item.routeName) > -1
        });

        menuComponents.push(
          <NavLink
            tabIndex={-1}
            className={className}
            routeName={item.routeName}
            navParams={item.navParams}
            key={item.routeName}
          >
            {item.label}
          </NavLink>
        );
      });
    }

    var icon = null;
    var thumbnailUrl = null;
    var props = {
      className: 'user-image small-user-image'
    };
    var imageId = currentUser.imageId;

    if (UserModel.isGuestAvatar(imageId)) {
      let isDefaultImage = UserModel.isDefaultImage(imageId);
      props.className = classnames('small-user-image avatar-' + UserModel.getGuestColor(), {
        'avatar-default': isDefaultImage
      });
      icon = <Icon name={UserModel.getGuestIcon(imageId)} />;
    } else {
      thumbnailUrl = UserModel.getThumbnailUrl(imageId, { width: 24, height: 24 });
      props.style = { backgroundImage: 'url(' + thumbnailUrl + ')' };
    }

    var network = getNetwork();
    var logoComponent = null;
    var style = {
      backgroundColor: network.color
    };
    if (isDefaultNetwork()) {
      // TODO: support new network props (imageId, color) from BE as well
      style.backgroundColor = 'black';
      logoComponent = <Icon name="openweb-white" className="logo" />;
    } else {
      var src = cloudinary.url(network.imageId, { height: 30, width: 30 });
      logoComponent = <img src={src} className="logo" />;
    }
    return (
      <div className="navigation-container">
        <div className="main-navigation">
          <div className="logo-container" onClick={this.navigateToSpot.bind(this)} style={style}>
            {logoComponent}
          </div>
          <SpotSelector
            currentUser={currentUser}
            currentRoute={currentRoute}
            isSuperAdmin={isSuperAdmin}
            text={text}
            hasDropdown={hasDropdown}
            spotId={spotId}
            spotSelector={spotSelector}
            ssoEnabled={ssoEnabled}
          />
          <div className="navigation">{showLinks ? menuComponents : null}</div>
          <div className="user-image-wrapper">
            <div {...props} onClick={this.openSettings.bind(this)}>
              {icon}
            </div>
            <div className="tooltip-wrapper" ref="settingsTooltip">
              <Tooltip
                className="dropdown tooltip-general"
                caret
                ref="menu"
                alignElement={() => this.refs.settingsTooltip}
                hasScreenBoundries
              >
                {this.openContextMenu()}
              </Tooltip>
            </div>
          </div>
        </div>
        <rn-banner
          className="animated animatedFadeInUp fadeInUp"
          font-family="'Open Sans', Courier, monospace"
          target="modal"
        ></rn-banner>
      </div>
    );
  }
}

MainNavigation.displayName = 'MainNavigation';
MainNavigation.defaultProps = {
  visible: true,
  hasDropdown: true,
  showLinks: true,
  isSuperAdmin: false
};

MainNavigation.propTypes = {
  visible: PropTypes.bool,
  route: PropTypes.object,
  text: PropTypes.string,
  hasDropdown: PropTypes.bool,
  selected: PropTypes.string,
  spotId: PropTypes.string,
  showLinks: PropTypes.bool,
  currentRoute: PropTypes.object,
  currentUser: PropTypes.object,
  isSuperAdmin: PropTypes.bool,
  isAdmin: PropTypes.bool,
  spot: PropTypes.object
};

MainNavigation.contextTypes = {
  getStore: PropTypes.func.isRequired,
  executeAction: PropTypes.func.isRequired
};

export default MainNavigation;
